/**
 * @fileoverview Constants for User Management module
 */
import { LanguageEnum } from "dmsbasereact";

/** @type {Array<{value: string, label: string}>} */
export const LANGUAGE_OPTIONS = [
  { value: LanguageEnum.PT_BR, label: "Português (Brasil)" },
  { value: LanguageEnum.ES_MX, label: "Español (México)" },
  { value: LanguageEnum.EN_US, label: "English (US)" },
];

/**
 * User status options for UI display
 * @type {Array<{value: number, label: string}>}
 */
export const STATUS_OPTIONS = [
  { value: 1, label: "Active" },
  { value: 0, label: "Inactive" },
];

/**
 * Account status enum values matching backend AccountStatusEnum.
 * @type {object}
 */
export const AccountStatusValue = {
  BLOCKED: -1,
  PENDING_CFM_VALIDATION: 1,
  PENDING_DOCUMENT_UPLOAD: 2,
  PENDING_APPROVAL: 3,
  PENDING_TRAINING: 4,
  ACTIVE: 5,
  REJECTED: 6,
  SUSPENDED: 7,
  PENDING_APPROVAL_GESTAO_LENA: 8,
  PENDING_APPROVAL_REGULATORIO: 9,
  PENDING_RECYCLING_TRAINING: 10,
};

/**
 * Account status options for external users (Person.account_status)
 * Maps to AccountStatusEnum in backend
 * @type {Array<{value: number, label: string}>}
 */
export const ACCOUNT_STATUS_OPTIONS = [
  { value: AccountStatusValue.BLOCKED, label: "Blocked" },
  { value: AccountStatusValue.PENDING_CFM_VALIDATION, label: "PendingCFMValidation" },
  { value: AccountStatusValue.PENDING_DOCUMENT_UPLOAD, label: "PendingDocumentUpload" },
  { value: AccountStatusValue.PENDING_APPROVAL, label: "PendingApproval" },
  { value: AccountStatusValue.PENDING_TRAINING, label: "PendingTraining" },
  { value: AccountStatusValue.ACTIVE, label: "Active" },
  { value: AccountStatusValue.REJECTED, label: "Rejected" },
  { value: AccountStatusValue.SUSPENDED, label: "Suspended" },
  { value: AccountStatusValue.PENDING_APPROVAL_GESTAO_LENA, label: "PendingApprovalGestaoLena" },
  { value: AccountStatusValue.PENDING_APPROVAL_REGULATORIO, label: "PendingApprovalRegulatorio" },
  { value: AccountStatusValue.PENDING_RECYCLING_TRAINING, label: "PendingRecyclingTraining" },
];

/**
 * Account status options valid for doctors.
 * Excludes statuses that are never part of the doctor approval flow:
 * - PENDING_DOCUMENT_UPLOAD: doctors don't upload documents
 * - PENDING_APPROVAL: legacy status replaced by PENDING_APPROVAL_GESTAO_LENA
 * - PENDING_APPROVAL_REGULATORIO: not in the current doctor flow
 * @type {Array<{value: number, label: string}>}
 */
export const DOCTOR_ACCOUNT_STATUS_OPTIONS = ACCOUNT_STATUS_OPTIONS.filter(
  (opt) => ![
    AccountStatusValue.PENDING_DOCUMENT_UPLOAD,
    AccountStatusValue.PENDING_APPROVAL,
    AccountStatusValue.PENDING_APPROVAL_REGULATORIO,
  ].includes(opt.value)
);

/** @type {object} */
export const MODAL_STYLE = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  maxWidth: "95vw",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 3,
};
